































import Vue, { PropType } from "vue";
import { MenuType } from "@/store/modules/simulation-resource-model-view-right-menu";
import SvgIcon from "@/components/SvgIcon.vue";
import StructureTree from "./structure-tree/index.vue";
import Atrribute from "./atrribute/index.vue";
import ComponentLookup from "./component-lookup/index.vue";

export default Vue.extend({
    components: { StructureTree, Atrribute, ComponentLookup, SvgIcon },
    props: {
        modelId: { type: String }
    },
    computed: {
        activeName(): MenuType {
            return this.$store.state.simulationRightMenuModule.activeName;
        },
        title(): string {
            return this.$store.getters["simulationRightMenuModule/activeMenuText"];
        },
        isTwoThree() {
            return this.$store.state.customSimulationModule.selectedSimulationDetail.classType === 5;
        }
    },
    methods: {
        getComponentIds(ids) {
            this.$emit("onTreeCheck", ids);
        },
        setActiveName(name) {
            this.$store.commit("simulationRightMenuModule/setActiveName", name);
        }
    },
    watch: {
        modelId: {
            async handler(val) {
                if (!val) return;
                if (!this.$store.state.sessionId) {
                    await this.$store.dispatch("getSessionId");
                }
                setTimeout(() => {
                    this.$store.dispatch("simulationRightMenuModule/init", { modelId: val });
                }, 200);
            },
            immediate: true
        },
       activeName: {
      handler(val: string) {
        if (val) {
          if (!this.isTwoThree) {
            this.$store.getters['modelViewModule/api'].PARAMS.ng_right = 450;
          }
        } else {
           this.$store.getters['modelViewModule/api'].PARAMS.ng_right = 0;
        }
      },
    },
    }
});
